"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var formik_1 = require("formik");
var React = tslib_1.__importStar(require("react"));
var getInitialValues_1 = require("./getInitialValues");
var getValidationSchema_1 = require("./getValidationSchema");
var SubFormContainer_1 = require("./SubFormContainer");
var validateSubForm_1 = require("./validateSubForm");
exports.SubForm = function (props) {
    var formikProps = props.formikProps, config = props.config, children = props.children, onValidationChange = props.onValidationChange, valuesKey = props.valuesKey, _a = props.validationOnMount, validationOnMount = _a === void 0 ? false : _a;
    var _b = React.useState(0), key = _b[0], setKey = _b[1];
    React.useEffect(function () {
        // Increment key change so that the subform re-renders when `dirty` changes to false - triggered by `formikProps.onReset()`
        if (!formikProps.dirty) {
            setKey(key + 1);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [formikProps.dirty, formikProps.touched]);
    return (React.createElement(formik_1.Formik, { key: key + "_" + valuesKey, onSubmit: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, false];
        }); }); }, initialValues: getInitialValues_1.getInitialValues(config, valuesKey), validationSchema: getValidationSchema_1.getValidationSchema(config, valuesKey), validateOnMount: validationOnMount }, function (subFormFormikProps) { return (React.createElement(SubFormContainer_1.SubFormContainer, { valuesKey: valuesKey, onValidationChange: onValidationChange, subFormFormikProps: subFormFormikProps }, children({
        subFormFormikProps: subFormFormikProps,
        validateSubForm: function () {
            return validateSubForm_1.validateSubForm(valuesKey, subFormFormikProps);
        },
        valuesKey: valuesKey
    }))); }));
};
//# sourceMappingURL=SubForm.js.map